import { InsuranceTypeCurrencyDto } from './insurance-type-currency.dto';
import { InsuranceTypeCoverageDto } from './insurance-type-coverage.dto';
import { InsuranceQuestionGroupDto } from './insurance-question-group.dto';
import { EnfermedadesGravesPlanDto } from './enfermedades-graves-plan.dto';
import { InsuranceRequirementBandDto } from './insurance-requirement-band.dto';
import { CoveragePlanDto } from './coverage-plan.dto';

export enum InsuranceCategory {
  Life = 'Life',
  Health = 'Health',
  Accident = 'Accident',
  Other = 'Other',
}

/** Max sum assured of the primary coverage for primary insureds aged ageFrom..ageTo (per currency). */
export interface AgeAmountLimitDto {
  ageFrom: number;
  ageTo: number;
  currency: string;
  maxAmount: number;
}

export interface InsuranceTypeDto {
  id: number;
  lob: number;
  slob: number;
  formulaId: string;
  name: string;
  icon: string;
  description: string;
  category: InsuranceCategory;
  durationMin?: number | null;
  durationMax?: number | null;
  minAge: number;
  maxAge: number;
  maxDurationAge: number;
  childMinAge?: number | null;
  childMaxAge?: number | null;
  childMaxDurationAge?: number | null;
  familyAllowed: boolean;
  allowBeneficiaries?: boolean;
  allowDependents?: boolean;
  requiresOccupation: boolean;
  priority: number;
  benefits: string[];
  currencies: InsuranceTypeCurrencyDto[];
  coverages: InsuranceTypeCoverageDto[];
  questionGroups: InsuranceQuestionGroupDto[];
  requirementBands: InsuranceRequirementBandDto[];
  seriousIllnessPlans?: EnfermedadesGravesPlanDto[];
  coveragePlans?: CoveragePlanDto[];
  ageAmountLimits?: AgeAmountLimitDto[];
}
